var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28C22.8513 28 28 22.8513 28 16.5C28 10.1487 22.8513 5 16.5 5C10.1487 5 5 10.1487 5 16.5C5 22.8513 10.1487 28 16.5 28Z",
    fill: "#CCE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9994 15.5001C24.1994 15.1001 26.8327 16.0001 27.9994 16.5001L27.499 19.5C27.1657 20.5 26.399 22.6 25.999 23L23.499 25.5V23C23.499 22.5 22.499 22 20.999 22C19.499 22 18.9994 20.5 18.4994 19.5C17.9994 18.5 18.9994 17.5 18.9994 16.5C18.9994 15.5 21.4994 16.0001 22.9994 15.5001Z",
    fill: "#D6D6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 6.00083C14.8012 4.40083 17.5012 5.00083 18.5012 5.50083L6.50117 21.0008C4.50117 20.5008 5.50117 13 6.00117 12C6.50117 11 8.50117 8.00083 12.0012 6.00083Z",
    fill: "#D6D6A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28C22.8513 28 28 22.8513 28 16.5C28 10.1487 22.8513 5 16.5 5C10.1487 5 5 10.1487 5 16.5C5 22.8513 10.1487 28 16.5 28Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88477 20.9242H8.98092C9.80207 20.9242 10.5896 20.598 11.1702 20.0174C11.7509 19.4367 12.0771 18.6492 12.0771 17.8281V15.1742C12.0771 14.3531 12.4033 13.5656 12.9839 12.9849C13.5646 12.4043 14.3521 12.0781 15.1732 12.0781C15.9944 12.0781 16.7819 11.7519 17.3625 11.1712C17.9432 10.5906 18.2694 9.80307 18.2694 8.98192V5.125",
    fill: "#D6D6A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88477 20.9242H8.98092C9.80207 20.9242 10.5896 20.598 11.1702 20.0174C11.7509 19.4367 12.0771 18.6492 12.0771 17.8281V15.1742C12.0771 14.3531 12.4033 13.5656 12.9839 12.9849C13.5646 12.4043 14.3521 12.0781 15.1732 12.0781C15.9944 12.0781 16.7819 11.7519 17.3625 11.1712C17.9432 10.5906 18.2694 9.80307 18.2694 8.98192V5.125",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 16.3229C27.1145 15.8633 26.1321 15.6207 25.1341 15.6152H21.3657C20.5445 15.6152 19.757 15.9414 19.1764 16.5221C18.5957 17.1027 18.2695 17.8902 18.2695 18.7114C18.2695 19.5325 18.5957 20.3201 19.1764 20.9007C19.757 21.4813 20.5445 21.8075 21.3657 21.8075C21.9522 21.8075 22.5147 22.0405 22.9295 22.4553C23.3442 22.87 23.5772 23.4325 23.5772 24.0191V25.5583",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.e3175c41d79e29cdfab28a79a45b0a10.svg";
export { ForwardRef as ReactComponent };